module.exports = __webpack_public_path__ + "prj_07.377955d6.jpeg";